import LoginForm from "../../componentes/LoginForm/LoginForm";

const Login = ({ handleLoginSuccess }) => {
  return <LoginForm handleLoginSuccess={handleLoginSuccess} />;
};

export default Login;
